import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const RequestsMobileCard = ({
  requests,
  selectedRequests,
  onSelectRequest,
  onViewRequest,
  onEditRequest,
  onDownloadRequest,
}) => {
  const getStatusBadge = (status) => {
    const statusConfig = {
      'در حال بررسی': {
        className: 'bg-warning/10 text-warning border-warning/20',
        icon: 'Clock',
      },
      'تکمیل شده': {
        className: 'bg-success/10 text-success border-success/20',
        icon: 'CheckCircle',
      },
      'نیاز به بازنگری': {
        className: 'bg-destructive/10 text-destructive border-destructive/20',
        icon: 'AlertCircle',
      },
    };

    const config = statusConfig?.[status] || statusConfig?.['در حال بررسی'];

    return (
      <span
        className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium border ${config?.className}`}>
        <Icon name={config?.icon} size={12} className="ml-1" />
        {status}
      </span>
    );
  };

  return (
    <div className="space-y-4">
      {requests?.map((request) => (
        <div
          key={request?.id}
          className="bg-card rounded-lg border border-border p-4">
          <div className="flex items-start justify-between mb-3">
            <div className="flex items-center space-x-3 space-x-reverse">
              <input
                type="checkbox"
                checked={selectedRequests?.includes(request?.id)}
                onChange={(e) =>
                  onSelectRequest(request?.id, e?.target?.checked)
                }
                className="rounded border-border focus:ring-2 focus:ring-primary"
              />
              <div className="flex items-center space-x-2 space-x-reverse">
                <Icon
                  name="FileText"
                  size={16}
                  className="text-muted-foreground"
                />
                <span className="font-medium text-foreground text-sm">
                  {request?.caseType}
                </span>
              </div>
            </div>
            {getStatusBadge(request?.status)}
          </div>

          <div className="mb-3">
            <h4 className="font-medium text-foreground mb-1">
              {request?.subject}
            </h4>
            <p className="text-sm text-muted-foreground">
              {request?.claimant} علیه {request?.respondent}
            </p>
          </div>

          <div className="flex items-center justify-between">
            <span className="text-sm text-muted-foreground">
              {request?.createdAt}
            </span>
            <div className="flex items-center space-x-1 space-x-reverse">
              <Button
                variant="ghost"
                size="sm"
                onClick={() => onViewRequest(request?.id)}
                className="h-8 px-2">
                <Icon name="Eye" size={14} className="ml-1" />
                مشاهده
              </Button>
              <Button
                variant="ghost"
                size="sm"
                onClick={() => onEditRequest(request?.id)}
                className="h-8 px-2">
                <Icon name="Edit" size={14} className="ml-1" />
                ویرایش
              </Button>
              {request?.status === 'تکمیل شده' && (
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => onDownloadRequest(request?.id)}
                  className="h-8 px-2 text-success hover:text-success">
                  <Icon name="Download" size={14} className="ml-1" />
                  دانلود
                </Button>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default RequestsMobileCard;
